import { render, staticRenderFns } from "./DefaultButton.vue?vue&type=template&id=16ca28e1&scoped=true&"
import script from "./DefaultButton.vue?vue&type=script&lang=js&"
export * from "./DefaultButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ca28e1",
  null
  
)

export default component.exports